import "./Layout.scss";
import { FooterSection } from "@components";

function Layout({title, subtitle, body}) {
    return (
        <div className="layout">
            <div className="header">
                <h1>{title}</h1>
                <p>{subtitle}</p>
            </div>
            <div className="body">
                {body}
            </div>
            <FooterSection />
        </div>
    );
}

export default Layout;